import { render, staticRenderFns } from "./changePasswordModal.vue?vue&type=template&id=a9da8920"
import script from "./changePasswordModal.vue?vue&type=script&lang=js"
export * from "./changePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./changePasswordModal.vue?vue&type=style&index=0&id=a9da8920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports